import fetcher from 'api/fetcher';

import urlParser from 'bloko/common/urlParser';

export default (key, setTranslation) => {
    const queryStr = urlParser.stringify({ key });
    fetcher
        .get(`/api/v1/admin/translations?${queryStr}`)
        .then((data) => {
            setTranslation(data);
        })
        .catch(() => setTranslation({}));
};
